import styled from '@emotion/styled';

import { hiddenScrollBar } from '../../../../../shared/utils/hidden-scrollbar';
import COLOR from '../../../../../shared/constant/colorset';

export * from '../ReviewRow/styled-components';

export const ThumbnailImage = styled.button<{ url: string }>`
  width: 124px;
  height: 124px;
  background: ${(props) => `url(${props.url}) no-repeat center`};
  background-size: cover;
  background-color: ${COLOR.bg};

  :first-of-type {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  :last-of-type {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;

export const ShowMore = styled.a`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  height: 124px;
  margin-bottom: 32px;
  border-radius: 0 6px 6px 0;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${COLOR.kurlyWhite};
  }
`;

export const SkeletonWrapper = styled.div`
  overflow: hidden;

  :first-of-type {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  :last-of-type {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  gap: 3px;
  width: 100%;
  border-radius: 6px;
  padding-bottom: 30px;
  overflow: hidden;
  ${hiddenScrollBar({ x: 'hidden', y: 'hidden' })}
`;

export const BackToList = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 168px;
  height: 56px;
  margin: auto;
  border: 1px solid ${COLOR.lightGray};
  border-radius: 3px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${COLOR.kurlyGray800};
  > svg {
    margin: 0 8px 0 4px;
  }
`;
